<template>
  <Table ref="table" :layers-filters="layersFilters" :is-custom-layer="true" :custom-layer-data="customLayerData">
  </Table>
</template>

<script>
import { get, sync } from 'vuex-pathify';

import Table from '@/components/Table';

export default {
  name: 'TableFolders',
  components: {
    Table,
  },
  computed: {
    activeTool: sync('tools/activeTool'),
    layerId: get('admin/modulesMapping@folders.layer_id'),
    layersFilters: get('layers/layersFilters'),
    customLayerData() {
      return {
        routeName: 'folder',
        eventName: 'toggleFolders',
        filterEventName: 'toggleFoldersFilter',
        layerId: this.layerId,
      };
    },
  },
  beforeCreate() {
    this.$once('hook:beforeDestroy', () => {
      this.$nextTick(() => {
        this.activeTool = undefined;
      });
      this.$root.$emit('toggleFolders', false);
    });
  },
};
</script>

<style scoped></style>
